import React, { useState } from "react";
import { SubscriptionType } from "../types/SubscriptionType";
// import { SubscriptionType } from "../types/SubscriptionType";

type SubscriptionListModalProps = {
    subscriptions: SubscriptionType[];
    handleEdit: (idx: number) => void;
    handleDelete: (idx: number) => void;
    showList: boolean;
    closeList: () => void;
};

const SubscriptionListModal: React.FC<SubscriptionListModalProps> = ({
    subscriptions,
    handleEdit,
    handleDelete,
    showList,
    closeList,
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(subscriptions, null, 2));
            setCopied(true);
            setTimeout(() => setCopied(false), 1200);
        } catch (e) {
            // ignore
        }
    };

    if (!showList) return null;
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.3)",
                zIndex: 2100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            onClick={closeList}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
                    minWidth: "320px",
                    maxWidth: "400px",
                    width: "90vw",
                    padding: "20px",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2>Gérer les abonnements</h2>
                <button
                    onClick={handleCopy}
                    style={{
                        marginBottom: "10px",
                        width: "100%",
                        background: "#6131ad",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        padding: "8px 0",
                        fontWeight: "bold",
                        fontSize: "15px",
                        cursor: "pointer",
                    }}
                >
                    Copier la configuration JSON
                </button>
                {copied && (
                    <div style={{ color: "green", textAlign: "center", marginBottom: 8 }}>
                        Copié !
                    </div>
                )}
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {subscriptions.map((sub, idx) => (
                        <li
                            key={sub.card}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #eee",
                                padding: "10px 0",
                            }}
                        >
                            <span>
                                <b>{sub.name}</b>{" "}
                                <span style={{ color: "#888" }}>({sub.card})</span>
                            </span>
                            <span>
                                <button
                                    onClick={() => handleEdit(idx)}
                                    style={{
                                        background: "#fefefe",
                                        color: "#6131ad",
                                        border: "1px solid #6131ad",
                                        borderRadius: "5px",
                                        padding: "5px 10px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        marginRight: "8px",
                                    }}
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(idx)}
                                    style={{
                                        background: "#fff0f0",
                                        color: "#fe2000",
                                        border: "1px solid #fe2000",
                                        borderRadius: "5px",
                                        padding: "5px 10px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    Delete
                                </button>
                            </span>
                        </li>
                    ))}
                </ul>
                <button
                    onClick={closeList}
                    style={{
                        marginTop: "20px",
                        width: "100%",
                        background: "#eee",
                        color: "#333",
                        border: "none",
                        borderRadius: "5px",
                        padding: "10px 0",
                        fontWeight: "bold",
                        fontSize: "16px",
                    }}
                >
                    Fermer
                </button>
            </div>
        </div>
    );
};

export default SubscriptionListModal; 